import { useState } from "react";
import { AlertTriangle, CircleSlash, Layers, Send } from "lucide-react";

import { NumberKpiCard } from "@/components/shared/NumberKpiCard";
import { useNotificacaoLogKpis } from "@/hooks/notificacao/use-notificacao-log-kpis";
import { PeriodoResumoNotificacao } from "@/types/notificacao-log.type";

import { PeriodoResumoSelect } from "../components/PeriodoResumoSelect";
import { NotificacaoEnviosOverview } from "../components/NotificacaoEnviosOverview";
import { NotificacaoLogResumoPorCanalList } from "../components/NotificacaoLogResumoPorCanalList";

const percentual = (parte: number, total: number) =>
  total > 0 ? Math.round((parte / total) * 100) : null;

export function PorCanalTab() {
  const [dias, setDias] = useState<PeriodoResumoNotificacao>(7);
  const { resumo, loading } = useNotificacaoLogKpis(dias);

  const pctEnviadas = percentual(resumo.totalEnviadas, resumo.totalGeral);
  const pctFalhas = percentual(resumo.totalFalhas, resumo.totalGeral);
  const pctIgnoradas = percentual(resumo.totalIgnoradas, resumo.totalGeral);

  return (
    <div className="space-y-6">
      <div className="flex justify-end">
        <PeriodoResumoSelect value={dias} onChange={setDias} />
      </div>

      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        <NumberKpiCard
          title="Total no período"
          value={resumo.totalGeral}
          icon={Layers}
          variant="blue"
          loading={loading}
        />
        <NumberKpiCard
          title="Enviadas"
          value={resumo.totalEnviadas}
          icon={Send}
          variant="emerald"
          loading={loading}
          hint={pctEnviadas !== null ? `${pctEnviadas}% do total` : undefined}
        />
        <NumberKpiCard
          title="Falhas"
          value={resumo.totalFalhas}
          icon={AlertTriangle}
          variant="destructive"
          loading={loading}
          hint={pctFalhas !== null ? `${pctFalhas}% do total` : undefined}
        />
        <NumberKpiCard
          title="Ignoradas"
          value={resumo.totalIgnoradas}
          icon={CircleSlash}
          variant="amber"
          loading={loading}
          hint={pctIgnoradas !== null ? `${pctIgnoradas}% do total` : undefined}
        />
      </div>

      <NotificacaoEnviosOverview dias={dias} />

      <NotificacaoLogResumoPorCanalList dias={dias} />
    </div>
  );
}
